let gcr_form_exists = document.querySelector(".sample_gcr_form");

if (Boolean(gcr_form_exists)) {

    let uniqueReferenceID = '';

    let pageLang = document.querySelector('html').getAttribute('lang') || document.documentElement.lang || 'en';
    let KoreanCustomer = false;

    let currentPageId = 'Landing_Page';
    let previousPageId = 'NA';
    window.handleAPIVersioning = () => {
        return true; // this will make sure we have V2 enebaled always
    }
    let isGCRV2Enabled = handleAPIVersioning();
    const v1Recaptcha = document.querySelector('.v1-recaptcha');
    const v2Recaptcha = document.querySelector('.v2-recaptcha');
    const koreaCustomerCheckbox = document.querySelector('#Korea-Customer');
    v2Recaptcha && v2Recaptcha.classList.remove('d-none');
    v1Recaptcha && v1Recaptcha.classList.add('d-none')

    const koreanCustomerSessionVariable = sessionStorage.getItem('IsKoreanCustomer') || false;
    const isGcrPrefetchEnable = JSON.parse(sessionStorage.getItem('isGcrPrefetchEnable') || false);

    if (koreanCustomerSessionVariable && koreanCustomerSessionVariable === 'true') {
        koreaCustomerCheckbox && koreaCustomerCheckbox.classList.remove('d-none');
    }

    let finalFileSubmitObj = {
        SOI_FileWidget: [],
        PI_FileWidget: [],
        POT_FileWidget: []
    };
    const userDetails = JSON.parse(sessionStorage.getItem('GatewayCustomer') || '{}');
    const state = JSON.parse(sessionStorage.getItem('state') || '{}');
    let englishCountryNameList = {};
    // Prefetching Customer details for R3 and R4
if (isGcrPrefetchEnable){
    let userDetailsObj = {
        sender_firstName :  userDetails?.name?.firstName ??  state?.updatedUserDetails?.gatewayCustomer?.name.first_name ?? '',
        sender_lastName : userDetails?.name?.lastName  ?? state?.updatedUserDetails?.gatewayCustomer?.name.last_name ?? '',
        sender_middleName :  userDetails?.name?.middleName ?? state?.updatedUserDetails?.gatewayCustomer?.name?.middle_name ?? '',
        sender_emailAddress : userDetails?.email ?? state?.updatedUserDetails?.gatewayCustomer?.email ?? '',
        sender_address_street :  userDetails?.address?.addrLine1 ?? state?.updatedUserDetails?.gatewayCustomer?.address?.addr_line1 ?? '',
        sender_address_state : userDetails?.address?.state ?? state?.updatedUserDetails?.gatewayCustomer?.address?.state ?? '',
        sender_address_zip :  userDetails?.address?.postalCode ?? state?.updatedUserDetails?.gatewayCustomer?.address?.postal_code ?? '',
        sender_address_city :  userDetails?.address?.city ?? state?.updatedUserDetails?.gatewayCustomer?.address?.city ?? '',
        sender_mobile_countryCode :  userDetails?.mobilePhone?.phoneNumber?.nationalNumber ??  state?.gatewayCustomer?.mobile_phone?.phone_number?.country_code,
        sender_mobile_telephone :  userDetails?.mobilePhone?.phoneNumber?.nationalNumber  ?? state?.updatedUserDetails?.gatewayCustomer?.contact_phone ?? ''
    }
    Object.entries(userDetailsObj).forEach(([key, selector]) => {
       let currentFormControl = document.getElementById(key) ;
       currentFormControl.value = selector
      });
    }

    const current_hostname = window.location.hostname;
    const header ={"Content-type": "application/json"};
    let fileSections = ['SOI_FileWidget', 'PI_FileWidget', 'POT_FileWidget'];
    
    window.getOnlyEnglishCountryNames = () => {
        let flagSelectParentList = document.querySelectorAll('.b-flag-select:not(.country-language-dropdown)')
        if (flagSelectParentList.length > 0) {
            const requestPayload = {
                country: flagSelectParentList[0].getAttribute('data-country'),
                language: flagSelectParentList[0].getAttribute('data-language'),
                host: flagSelectParentList[0].getAttribute('data-host')
            }
            const getCountryListConfig = triggerCountryList(requestPayload);
            const headers = {
                'content-type': 'application/JSON'
            }
            httpRequest.get(`${getHttpRequestUrl()}content/wucom/base/global/config/activeVersion.json`)
            .then((versionInfo) => {
                httpRequest.post(`${getCountryListConfig.url}?dcaasversion=${versionInfo.dcaasVersion}`, getCountryListConfig.reqPayload, headers)
                .then((response) => {
                    englishCountryNameList = response.COUNTRY_LIST
                })
            })
        }
    }
    getOnlyEnglishCountryNames();
    
    window.V2GRVerify = () => {
        const loadingSpinner = document.querySelector(".gcr-form-wu-spinner");
        const errorMsg = document.querySelector(".gcr-msg-fail");
        const humankey = document.querySelector(".v2-recaptcha #g-recaptcha-response");
        const humanKey = humankey ? humankey.value : '';
        const submitUrl = `https://${current_hostname}/cmplkyc/gcr/v2/captchaVerify`;
        const headers = { "Content-type": "application/json" };
        const payload = { humanKey: humanKey };
        
        loadingSpinner && errorMsg && loadingSpinner.classList.remove('d-none') && errorMsg.classList.add('d-none');

        const osme = httpRequest.post(submitUrl, payload, headers).then(response => {
            loadingSpinner.classList.add('d-none');
            if (response) {
                if (!(response.error || response.errorCode)) {
                    errorMsg.classList.add('d-none');
                    return {
                        responseBody: response,
                        responseCode: 'S'
                    };
                } else {
                    errorMsg.classList.remove('d-none');
                    return {
                        responseBody: response,
                        responseCode: 'E'
                    };
                }
            } else {
                errorMsg.classList.remove('d-none');
                return {
                    responseCode: 'U'
                };
            }
        }).catch(error => {
            loadingSpinner.classList.add('d-none');
            errorMsg.classList.remove('d-none');
            return {
                responseBody: error,
                responseCode: 'E'
            };
        });
        return osme;
    }

    window.setValue = (object, keys, value) => {
        let last = keys.pop();
        keys.reduce((o, k) => o[k] = o[k] || {}, object)[last] = value;
    }

    window.fetchCountrySearchValue = (sectionContents, formDataObject) => {
        const countrySearchSelect = sectionContents.querySelectorAll('input[data-type="search"]');
        if (countrySearchSelect && countrySearchSelect.length) {
            countrySearchSelect.forEach(selector => {
                const selectorId = selector.id.split('_');
                const labelId = `${selector.id}_label`;
                const labelElem = document.getElementById(`${labelId}`);
                setValue(formDataObject, selectorId, labelElem.innerText);
            })
        };
    }


    
    window.getCountryInEng = (langCode) => {
        return englishCountryNameList[langCode]; // set native lang english content
    }

    window.handleCountrySelectZIndex = (event, value) => {
        event.target && value.length && value === 'high' ? event.target.parentElement.parentElement.parentElement.classList.add('z-highest') : value === 'low' ? event.target.parentElement.parentElement.parentElement.classList.remove('z-highest') : '';
    }

    // for [] and {} , use [].length and Object.keys({}).length as arguments
    window.undefinedCheck = (...a) => [...a].reduce((accu, curr) => Boolean(accu) && Boolean(curr), true);
    let sectionCounter = 0;

    let currentDate = new Date();
    const formattedDate = (`${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`)
    const TZoffset = currentDate.getTimezoneOffset();    
    currentDate = (new Date(currentDate.getTime() - (TZoffset * 60 * 1000))).toISOString().split('T')[0];

    let dobControl = document.getElementById('thirdPartyDetails_dateofBirth');
    dobControl ? (dobControl.setAttribute('max', currentDate), dobControl.setAttribute('data-value', ''), dobControl.setAttribute('min', '1880-01-01')) : '';
    
	window.checkDevice = () => {
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
			return true;
		}
		return false;
	}

    window.showSC_Page = (targetPage, currentPage) => {
        const isGCRV2Enabled = handleAPIVersioning();
        if (currentPage == "Landing_Page") {
            if (isGCRV2Enabled) {
                //v2 Flow
                V2GRVerify().then(response => {
                    response.responseCode === 'S' && response.responseBody && response.responseBody.captchaUuid && (uniqueReferenceID = response.responseBody.captchaUuid) && showSC_Page2(targetPage, currentPage);
                }).catch(error => {
                    console.error(response.responseBody, error);
                })
            } else {
                //v1 Flow
                showSC_Page2(targetPage, currentPage);
            }
        } else if (currentPage == "success_page") {
            window.location.href = prodUrl;
        }
    }

    window.showSC_Page2 = (targetPage, currentPage) => {
        let startEventLog = document.getElementById('button-start-questionnaire');
        sortSelect(document.querySelector("#sender_mobile_countryCode"));
        sortSelect(document.querySelector("#thirdPartyDetails_telephone_countryCode"));
        addEmptyElement(document.querySelector("#sender_mobile_countryCode"));
        addEmptyElement(document.querySelector("#thirdPartyDetails_telephone_countryCode"));
        if (checkDevice()) {
            let showFWEditOption_Mob = document.querySelectorAll('.choose_doc, .choose_photo, .use_camera');
            showFWEditOption_Mob.forEach(className => {
                className.classList.remove("d-none");
            });
            let showFWEditOption_Des = document.querySelectorAll('.choose_file');
            showFWEditOption_Des.forEach(className => {
                className.classList.add("d-none");
            });
        }
        startEventLog && startEventLog.click();
        redirectToPage(targetPage, currentPage);
    }

    window.redirectToPage = (targetPage = 'NA', currentPage) => {
        let trgtpg;
        if (targetPage === 'NA') {
            currentPageId = previousPageId;
            trgtpg = document.getElementById(previousPageId);
        } else {
            currentPageId = targetPage
            trgtpg = document.getElementById(targetPage);
        }

        const crntpg = document.getElementById(currentPage);
        previousPageId = currentPage;

        crntpg && crntpg.classList.add('d-none');
        trgtpg && trgtpg.classList.remove('d-none');
    }

    let thirdPartySelector = document.querySelector('[name="thirdPartyDetails.individualorBusiness"]');
    window.thirdPartySelectHandler = (event) => {
        const control = event.target;
        const optionId = control[control.selectedIndex].id.split('_');
        let commonControlsList = ['relationship', 'relationshipDetails', 'relationshipFullName', 'relationshipAddress_street', 'relationshipAddress_city',  'relationshipAddress_state', 'relationshipAddress_zip', 'relationshipAddress_country'];
        let businessControlsList = ['industry', 'industryDetails', 'website'];
        let individualControlsList = ['dateofBirth', 'occupation', 'occupationDetails', 'telephone_countryCode', 'telephone_telephone'];
        if (control && control.value) {
            commonControlsList.forEach((fieldName) => {
                let field = document.getElementById(`thirdPartyDetails_${fieldName}`);
                field.value = "";
                fieldName !== 'relationshipAddress_country' ? field.parentElement.parentElement.classList.remove('d-none') : field.parentElement.parentElement.parentElement.classList.remove('d-none');
                !(fieldName === 'relationshipAddress_zip' || fieldName === 'relationshipDetails' || fieldName === 'relationshipAddress_country') ? field.parentElement.parentElement.classList.add('reqValidate') : '';
                fieldName === 'relationshipDetails' ? field.parentElement.parentElement.classList.add('d-none') : '';
                control.checked ? '' : field.parentElement.classList.contains('wu-input__error') ? field.parentElement.classList.remove('wu-input__error') : '';
            });
            let relationshipSelector = document.getElementById('thirdPartyDetails_relationship');

            let selectorLabel = document.querySelector('#label_thirdPartyDetails_relationshipSelect');
            let inputLabel = document.querySelector('#label_thirdPartyDetails_relationshipName');

            let relationNameInput = document.getElementById('thirdPartyDetails_relationshipFullName').nextElementSibling;
            let labelMsg = document.getElementById('thirdPartyDetails_relationship_msg');

            if (optionId.includes('individual')) {
                labelMsg && selectorLabel && inputLabel && relationNameInput ? (labelMsg.innerText = selectorLabel.innerText.split('_')[0], relationNameInput
                    .innerText = inputLabel.innerText.split('_')[0] , relationNameInput.nextElementSibling.classList.remove('d-none')) : '';
                for (i = 0; i < relationshipSelector.options.length; i++) {
                    let option = relationshipSelector.options[i];
                    let optionId = option.id.split('_');
                    optionId.includes('individual') ? option.classList.remove('d-none') : option.classList.add('d-none');
                }
                individualControlsList.forEach((fieldName) => {
                    let field = document.getElementById(`thirdPartyDetails_${fieldName}`);
                    if (field) {
                        !field.id.includes('occupationDetails') ? field.parentElement.parentElement.classList.remove('d-none') : '';
                        !field.id.includes('occupationDetails') ? field.parentElement.parentElement.classList.add('reqValidate') : '';
                        control.checked ? '' : field.parentElement.classList.contains('wu-input__error') ? field.parentElement.classList.remove('wu-input__error') : '';
                    }
                });
                businessControlsList.forEach((fieldName) => {
                    let field = document.getElementById(`thirdPartyDetails_${fieldName}`);
                    if (field) {
                        field.parentElement.parentElement.classList.add('d-none');
                        field.parentElement.parentElement.classList.remove('reqValidate');
                        control.checked ? '' : field.parentElement.classList.contains('wu-input__error') && field.parentElement.classList.remove('wu-input__error');
                    }
                });
            } else if (optionId.includes('business')) {
                labelMsg && selectorLabel && inputLabel && relationNameInput ? (labelMsg.innerText = selectorLabel.innerText.split('_')[1], relationNameInput
                    .innerText = inputLabel.innerText.split('_')[1], relationNameInput.nextElementSibling.classList.add('d-none')) : '';
                for (i = 0; i < relationshipSelector.options.length; i++) {
                    let option = relationshipSelector.options[i];
                    let optionId = option.id.split('_');
                    optionId.includes('business') ? option.classList.remove('d-none') : option.classList.add('d-none');
                }
                individualControlsList.forEach((fieldName) => {
                    let field = document.getElementById(`thirdPartyDetails_${fieldName}`);
                    if (field) {
                        field.parentElement.parentElement.classList.add('d-none');
                        field.parentElement.parentElement.classList.remove('reqValidate');
                        control.checked ? '' : field.parentElement.classList.contains('wu-input__error') ? field.parentElement.classList.remove('wu-input__error') : '';
                    }
                });
                businessControlsList.forEach((fieldName) => {
                    let field = document.getElementById(`thirdPartyDetails_${fieldName}`);
                    if (field) {
                        !field.id.includes('industryDetails') ? field.parentElement.parentElement.classList.remove('d-none') : '';
                        !field.id.includes('industryDetails') ? field.parentElement.parentElement.classList.add('reqValidate'): '';
                        control.checked ? '' : field.parentElement.classList.contains('wu-input__error') ? field.parentElement.classList.remove('wu-input__error') : '';
                    }
                });
            }
        }
    }
    undefinedCheck(thirdPartySelector) ? thirdPartySelector.addEventListener('change', window.thirdPartySelectHandler) : '';


    // Add Countrparty by Clicking on 'Add Another Person' link
    window.addAnotherPerson = () => {
        const relationshipSection = document.getElementById('form-section-Relationship');
        const subSections = document.querySelectorAll('.single_user_details_Relationship');
        const restrictMsg = document.querySelector(".gcr-msg-add-person-stop");
        const failureMsg = document.querySelector(".gcr-msg-add-person-fail");
        const addPersonCTA = document.querySelector("#section-adder-link");
        if (relationshipSection && subSections && subSections.length) {
            if (subSections.length < 5) {
                subSections.length === 4 && addPersonCTA && addPersonCTA.classList.add('d-none');
                restrictMsg && failureMsg ? (restrictMsg.classList.add('d-none'), failureMsg.classList.add('d-none')) : '';
                const singleSubSection = subSections[0].cloneNode(true);
                if (singleSubSection) {
                    const subSectionFormControls = singleSubSection.querySelectorAll('input,select');
                    if (subSectionFormControls && subSectionFormControls.length) {
                        subSectionFormControls.forEach(formControl => {
                            if (formControl.name && formControl.id) {
                                const newFormControlName = `${formControl.name.slice(0, -1)}${subSections.length}`;
                                formControl.value = "";
                                formControl.name = newFormControlName;
                                formControl.id = `${formControl.id.slice(0, -1)}${subSections.length}`;
                                if (formControl.name.includes('Details')) {
                                    const fieldDivClass = formControl.parentElement.classList;
                                    const fieldWrapperClass = formControl.parentElement.parentElement.classList;
                                    fieldDivClass.remove('wu-input__error', 'reqValidate');
                                    fieldWrapperClass.add('d-none');
                                }
                            }
                        });
                        relationshipSection.appendChild(singleSubSection);
                        singleSubSection.firstElementChild.nextElementSibling.classList.replace('d-none', 'd-flex');
                    }
                }
            } else {
                restrictMsg ? (restrictMsg.classList.remove('d-none'), window.scrollTo(0, 0)) : '';
            }
        } else {
            failureMsg ? (failureMsg.classList.remove('d-none'), window.scrollTo(0, 0)) : '';
        }
    }

    window.removeAnotherPerson = (event) => {
        event.target.parentElement.parentElement.remove();
        const addPersonStopMsg = document.querySelector(".gcr-msg-add-person-stop");
        const addPersonFailMsg = document.querySelector(".gcr-msg-add-person-fail");
        const addPersonCTA = document.querySelector("#section-adder-link");
        addPersonFailMsg && addPersonStopMsg && addPersonCTA && (addPersonFailMsg.classList.add('d-none'), addPersonStopMsg.classList.add('d-none'), addPersonCTA.classList.remove('d-none'));
    }
    // Validate Text Input
    window.validateInput = (event, type) => {
        if(type == "countryCode"){
            let selectedCountryCode = event.target.value.split('(');
            selectedCountryCode= selectedCountryCode[1].split(')');
            selectedCountryCode = selectedCountryCode[0];
        }
        const fieldValidity = event.target.validity.valid;
        const wrapper = event.target.parentElement;
        const container = event.target.parentElement.parentElement;
        const patternMatch = matchPattern(event.target.value, type);
        const inputId = event.target.id;

        let optionalField = false;

        (inputId.includes('zip') || inputId.includes('mtcn') || inputId.includes('middleName')) && (optionalField = true);
        
        if (optionalField) {
            event.target.value.length === 0 ? (wrapper.classList.remove('wu-input__error'), container.classList.remove('reqValidate')) : fieldValidity && patternMatch ? (wrapper.classList.remove('wu-input__error'), container.classList.remove('reqValidate')) : (wrapper.classList.add('wu-input__error'), container.classList.add('reqValidate'));
        } else {
            fieldValidity && patternMatch ? wrapper.classList.remove('wu-input__error') : wrapper.classList.add('wu-input__error');
        }
    }

    window.matchPattern = (inputValue, inputType) => {
        let succesfulMatch = false;
        const patternObj = {
            text: /^(?! )(?!(.)\1+$)(?!.*(.)\2{2})(?!.*( |'|-|\.)\3{1})(?=\S*(\s\S*){0,4}$)(?=[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*(['-][a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*){0,2}$)(?=(.*[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ.]){2}.*$)^[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ '-.]{0,}\S$/,
            address: /[\s\S]*/,
            select: /[\s\S]*/,
            zip: /(?=^([a-zA-Z\d]{2}))(?!0{3,5})[A-Za-z0-9 -]{3,10}$/,
            webaddress: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/,
            search: /^(?! )(?!(.)\1+$)(?!.*(.)\2{2})(?!.*( |'|-|\.)\3{1})(?=\S*(\s\S*){0,4}$)(?=[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*(['-][a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*){0,2}$)(?=(.*[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ.]){2}.*$)^[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ '-.]{0,}\S$/,
            email: /^(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/,
            number: /^(?!(.)\1+$)^(|[0-9]{7,})$/,
            mtcn: /^[\d]{10}$/,
            countryCode: /^[+0-9A-Z\(\)]{6,8}$/,
            date: /^(\d{4})\-(\d{2})\-(\d{2})$/
        }
        patternObj[inputType].test(inputValue) && (succesfulMatch = true);
        return succesfulMatch;
    }

    window.validateNumericInput = (event, type) => {
        isNaN(Number(event.data)) ? event.target.value = event.target.value.replace(event.data, "") : validateInput(event, type);
    }

    let sectionsArray = [false, false, false, false, false, false];


    window.scrollToFormError = (formBeingChecked, indexToMoveTo) => {
        const elementError = formBeingChecked.querySelector('.wu-input__error:not([hidden])') || formBeingChecked.querySelector('.text-danger:not([hidden])');
        if(elementError) {
            elementError.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center'
            }) 
        } else {
            const elementNext = document.getElementById(`setOverflowVisCont_${indexToMoveTo + 1}`);
            elementNext?.scrollIntoView({ 
            behavior: 'smooth'
            }) 
        }
    }

    // Validate Section Inputs and Select Menus on hit of Continue
    window.validateGCRSection = (togglerID, buttonID, b = 'click', callnext = true) => {
        
        let togglerNameString = undefinedCheck(togglerID) ? String(togglerID) : '';
        let togglerNumericId = undefinedCheck(togglerNameString) ? Number(togglerNameString[togglerNameString.length - 1]) : '';
        let btnNameString = undefinedCheck(buttonID) ? String(buttonID) : '';
        let btnNumericId = undefinedCheck(btnNameString) ? Number(btnNameString[btnNameString.length - 1]) : '';
        let formBeingChecked = document.getElementById(`setOverflowVisCont_${btnNumericId}`);
        let fieldsValid = true;
        let toggleElement = document.getElementById(`${togglerID}`);
        let btnElement = document.getElementById(`${buttonID}`);
        let newtogglerId = `${togglerNameString.slice(0, -1)}${String(togglerNumericId + 1)}`;
        let newBtnId = `${btnNameString.slice(0, -1)}${String(btnNumericId + 1)}`;
        let isGCRV2Enabled = handleAPIVersioning();
        if (undefinedCheck(btnElement) && undefinedCheck(toggleElement)) {
            let section = btnElement.parentElement.parentElement.parentElement;
            if (undefinedCheck(section)) {
                let formControls = section.querySelectorAll('.reqValidate');
                if (undefinedCheck(formControls.length) && b === 'click' ) {
                    for (let i = 0; i < formControls.length; i++) {
                        let formFields = formControls[i].querySelectorAll('input:not([type="file"],[data-type="search"]), select');  
                        if (undefinedCheck(formFields.length)) {
                            formFields.forEach(formField => {
                                let formFieldType = formField.getAttribute('data-type');
                                (undefinedCheck(formField.value.trim()) && formField.validity.valid && matchPattern(formField.value,formFieldType)) ?
                                    (formField.parentElement.classList.remove('wu-input__error')) :
                                    (formField.parentElement.classList.add('wu-input__error'), fieldsValid = false );
                            });
                        }
                    }
                }
                if (isGCRV2Enabled) {
                    submitMultipleFiles();
                    let files = section.querySelectorAll('[type="file"].reqValidate');
                    window.scrollToFormError(formBeingChecked, btnNumericId);
                    // document.querySelector(".wu-input--error").scrollIntoView({ behavior: "smooth", block: "center" });
                    if (files.length && b === 'click') {
                        let arrayLabel = files[0].id.slice(0, -3);
                        let fileHeading = document.querySelector(`#${arrayLabel}_Heading`);
                        let fileLabel = document.querySelector(`#${arrayLabel}_Label`);
                        if ((finalFileSubmitObj[arrayLabel] && finalFileSubmitObj[arrayLabel].length)) {
                            fileHeading && fileLabel && (fileHeading.classList.remove('text-danger'), fileLabel.classList.remove('text-danger'));
                        } else {
                            fileHeading && fileLabel && (fileHeading.classList.add('text-danger'), fileLabel.classList.add('text-danger'));
                            fieldsValid = false;
                        }
                    }
                } else {
                    let files = section.querySelectorAll('[type="file"].reqValidate');
                    if (undefinedCheck(files.length) && b === 'click') {
                        let fileId = files[0].id.slice(0, -3);
                        let fileLabel = document.getElementById(`${fileId}_Label`);
                        let fileHeading = document.getElementById(`${fileId}_Heading`);
                        if (undefinedCheck(attachmentData[fileId])) {
                            if (undefinedCheck(attachmentData[fileId].data) && undefinedCheck(attachmentData[fileId].fileName)) {       
                                fileHeading && fileLabel && (fileHeading.classList.remove('text-danger'), fileLabel.classList.remove('text-danger'));
                            } else {
                                fileHeading && fileLabel && (fileHeading.classList.add('text-danger'), fileLabel.classList.add('text-danger'));
                                fieldsValid = false;
                            }
                        } else {
                            fileHeading && fileLabel && (fileHeading.classList.add('text-danger'), fileLabel.classList.add('text-danger'));
                            fieldsValid = false;
                        }
                    }
                }
                
                if (fieldsValid && b === 'click') {
                    sectionsArray[togglerNumericId - 1] = true;
                    let title1 = document.getElementById(`section_title_${togglerNumericId}`);
                    title1 ? title1.classList.remove('text-danger') : '';                    
                    if (toggleElement.checked) toggleElement.checked = !toggleElement.checked;
                    else toggleElement.checked = toggleElement.checked;
                    if (togglerNumericId <= 5) {
                        let newSectionToggler = document.getElementById(`${newtogglerId}`);
                        let newSectionBtn = document.getElementById(`${newBtnId}`);
                        if (undefinedCheck(newSectionToggler) && undefinedCheck(newSectionBtn)) {
                            let newclick = 'clickcall';
                            if (!sectionsArray[togglerNumericId]) {
                                if (callnext) {
                                    validateGCRSection(newtogglerId, newBtnId, newclick);
                                    // newSectionBtn.parentElement.parentElement.parentElement.scrollIntoView({
                                    //     behavior: 'smooth',
                                    //     block: 'start',
                                    //     inline: 'nearest'
                                    // });
                                    setTimeout(() => {
                                        const elementNext = document.getElementById(`setOverflowVisCont_${btnNumericId}`);
                                        elementNext?.scrollIntoView({ 
                                        behavior: 'smooth'
                                        }) 
                                    },500)
                                }
                            }
                        }
                    } else {
                        window.scrollToFormError(formBeingChecked, btnNumericId);
                    }
                } else {
                    if (!sectionsArray[togglerNumericId - 1]) {
                        let title = document.getElementById(`section_title_${togglerNumericId}`);
                        title ? title.classList.add('text-danger') : '';
                        if (toggleElement.checked) toggleElement.checked = toggleElement.checked;
                        else {
                            toggleElement.checked = !toggleElement.checked;
                            section.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                                inline: 'nearest'
                            });
                        }
                }
                }
            }
        }
        return fieldsValid;
    }

    window.validateForm = () => {
        let sectionValid = true;
        for (let i = 1; i <= 6; i++) {
        let validity = validateGCRSection(`toggle${i}`, `continueButton_${i}`, 'click', false);
        if (!validity) {
                sectionValid = false;
                sectionsArray[i - 1] = false;
                validateGCRSection(`toggle${i}`, `continueButton_${i}`, 'click', false);
                break;
            }
        }
        return sectionValid;
    }


    // Show Free Text when Other is Selected
    window.promptDetails = (event) => {
        const element = event.target;
        if (element && element.value) {
            element.parentElement.classList.remove('wu-input__error');
            const optionId = element[element.selectedIndex].id.split('_');
            let detailsFieldName = '';
            element.name.split('.')[0] === 'relationship' ? detailsFieldName = `${element.name.slice(0,-1)}Details${element.name.slice(-1)}` : detailsFieldName = `${element.name}Details`;
            optionId.includes('other') ? toggleField('name', detailsFieldName, false, true) : toggleField('name', detailsFieldName);
        } else {
            element.parentElement.classList.add('wu-input__error');
        }
    }

    window.toggleField = (attr, value, hide = true, required = false) => {
        const field = document.querySelector(`[${attr}="${value}"]`);
        if (field) {
            const fieldDivClass = field.parentElement.classList;
            const fieldWrapperClass = field.parentElement.parentElement.classList;
            if (fieldDivClass && fieldWrapperClass) {
                hide ? (field.value = "", fieldDivClass.remove('wu-input__error'), fieldWrapperClass.add('d-none'), fieldWrapperClass.remove('reqValidate')) : (fieldWrapperClass.remove('d-none'), required ? fieldWrapperClass.add('reqValidate') : '');
            }
        }
    }

    // Form Submit window.
    window.gcrFormSubmit = (e) => {
        e.preventDefault();

        let humankey = document.querySelector(".v1-recaptcha #g-recaptcha-response-1");
        let humanKey = humankey ? humankey.value : '';
        let isGCRV2Enabled = handleAPIVersioning();

        isGCRV2Enabled && (humanKey = 'abc');

        if (validateForm() && humanKey) {
            let formDataObject = {
                "sender": {
                    "date": formattedDate,
                    "name": {
                        "name_type": "D"
                    },
                    "address": {},
                    "mobile": {},
                },
                "relationship": [],
                "purposeofTransfer": {},
                "sourceofIncome": {
                    "sourceofIncome": '',
                },
                "thirdPartyDetails": {
                    "isThirdParty": "",
                    "isIorB": "",
                    "relationshipAddress": {},
                },
                "fraudClaims": {
                    "fraudClaims": '',
                    "writeHere": ''
                }
            };

            if (isGCRV2Enabled) {
                if (formDataObject.sender && formDataObject.purposeofTransfer && formDataObject.sourceofIncome && finalFileSubmitObj) {
                    formDataObject.sender.gcrIdDocuments = finalFileSubmitObj.PI_FileWidget;
                    formDataObject.purposeofTransfer.potDocuments = finalFileSubmitObj.POT_FileWidget;
                    formDataObject.sourceofIncome.sofDocuments = finalFileSubmitObj.SOI_FileWidget;
                }
            } else {
                if (formDataObject.sender && formDataObject.purposeofTransfer && formDataObject.sourceofIncome && attachmentData) {
                    formDataObject.sender.gcrIdDocuments = [attachmentData.PI_FileWidget];
                    formDataObject.purposeofTransfer.potDocuments = [attachmentData.POT_FileWidget];
                    formDataObject.sourceofIncome.sofDocuments = [attachmentData.SOI_FileWidget];
                }
            } 

            isGCRV2Enabled ? (formDataObject.captchaUuid = uniqueReferenceID) : (formDataObject.humanKey = humanKey);

            let sourceofincome = document.querySelector('[name="sourceofIncome.sourceofIncome"]');
            sourceofincome && sourceofincome.value ? formDataObject.sourceofIncome.sourceofIncome = sourceofincome.value : '';

            let sourceofincomedetails = document.querySelector('[name="sourceofIncome.sourceofIncomeDetails"]');
            sourceofincomedetails && sourceofincomedetails.value ? formDataObject.sourceofIncome.sourceofIncomeDetails = sourceofincomedetails.value : '';

            let fraudclaims = document.getElementById("fraudClaims");
            fraudclaims ? fraudclaims.checked ? formDataObject.fraudClaims.fraudClaims = "Y" : formDataObject.fraudClaims.fraudClaims = "N" : '';

            let fraudclaimstext = document.querySelector('[name="fraudClaims.writeHere"]');
            fraudclaimstext && fraudclaimstext.value ? formDataObject.fraudClaims.writeHere = fraudclaimstext.value : '';

            const relationshipSection = document.getElementById('form-section-Relationship');
            if (relationshipSection) {
                const allRelationhsips = relationshipSection.querySelectorAll('.single_user_details_Relationship');
                if (allRelationhsips && allRelationhsips.length) {
                    allRelationhsips.forEach(section => {
                        if (section) {
                            let dataObject = {};
                            let firstName = section.querySelector('[id^="relationship_firstName"]');
                            let middleName = section.querySelector('[id^="relationship_middleName"]');
                            let lastName = section.querySelector('[id^="relationship_lastName"]');
                            let relationship = section.querySelector('[id^="relationship_relationship"]');
                            let relationshipdetails = section.querySelector('[id^="relationship_relationshipDetails"]');
                            let purposeoftransfer = section.querySelector('[id^="relationship_purposeofTransfer"]');
                            let purposeoftransferdetails = section.querySelector('[id^="relationship_purposeofTransferDetails"]');
                            let haveyoumet = section.querySelector('[id^="relationship_haveYouMet"]');

                            middleName && middleName.value ?
                                (firstName && firstName.value && lastName && lastName.value) ? dataObject.fullName = `${firstName.value.trim()} ${middleName.value.trim()} ${lastName.value.trim()}` : '' :
                                (firstName && firstName.value && lastName && lastName.value) ? dataObject.fullName = `${firstName.value.trim()} ${lastName.value.trim()}` : '';
                            relationship && relationship.value ? dataObject.relationship = relationship.value : '';
                            purposeoftransfer && purposeoftransfer.value ? dataObject.purposeofTransfer = purposeoftransfer.value : '';
                            haveyoumet && haveyoumet.value ? dataObject.haveYouMet = haveyoumet.value : '';
                            relationshipdetails && relationshipdetails.value ? dataObject.relationshipDetails = relationshipdetails.value : '';
                            purposeoftransferdetails && purposeoftransferdetails.value ? dataObject.purposeofTransferDetails = purposeoftransferdetails.value : '';
                            formDataObject.relationship.push(dataObject);
                        }
                    });
                }
            }
            const personalData = document.getElementById('form-section-PersonalInformation');
            if (personalData) {
                let personalInfoFormControls = personalData.querySelectorAll('input:not([type="file"],[data-type="search"]), select:not([id^="select"])');
                if (personalInfoFormControls && personalInfoFormControls.length) {
                    personalInfoFormControls.forEach(formField => {
                        if (formField) {
                            let fieldName = (formField.id.split('_'));
                            let fieldNameLen = fieldName.length;
                            let key = fieldName[fieldNameLen - 1];
                            let value = formField.value.trim();
                            if (formField.id.includes('sender_address_country_List')) formDataObject.sender.address.country = value;
                            else if (formField.id.includes('sender_countryofBirth_List')) formDataObject.sender.countryofBirth = value;
                            else if (formField.id.includes('Name')) value ? formDataObject.sender.name[key] = value : '';
                            else if (formField.id.includes('address')) value ? formDataObject.sender.address[key] = value : '';
                            else if (formField.id.includes('countryCode')) formDataObject.sender.mobile[key] = value.slice(0, -4);
                            else if (formField.id.includes('telephone')) formDataObject.sender.mobile[key] = value;
                            else value ? formDataObject.sender[key] = value : '';
                        }
                    })
                }
                fetchCountrySearchValue(personalData, formDataObject);
            }
            const thidPartyData = document.getElementById('form-section-thirdPartyDetails');
            let control = document.getElementById('thirdPartyDetails');
            if (thidPartyData && control) {
                if (!control.checked) {
                    formDataObject.thirdPartyDetails = {
                        "isThirdParty": "N"
                    }
                } else {
                    formDataObject.thirdPartyDetails.isThirdParty = "Y";
                    let thirdPartySelector = document.querySelector('[name="thirdPartyDetails.individualorBusiness"]');
                    if (thirdPartySelector && thirdPartySelector.value) {
                        const optionId = thirdPartySelector[thirdPartySelector.selectedIndex].id.split('_');
                        optionId.includes('individual') ? (formDataObject.thirdPartyDetails.isIorB = "I") : optionId.includes('business') ? (formDataObject.thirdPartyDetails.isIorB = "B") : '';
                    }
                    let thirdPartyFormControls = thidPartyData.querySelectorAll('input:not([type="checkbox"],[data-type="search"]), select:not([id^="select"])');
                    if (thirdPartyFormControls && thirdPartyFormControls.length) {
                        thirdPartyFormControls.forEach(formField => {
                            if (formField) {
                                let fieldName = (formField.id.split('_'));
                                let fieldNameLen = fieldName.length;
                                let key = fieldName[fieldNameLen - 1];
                                let value = formField.value.trim();
                                if (formField.id.includes('relationshipAddress_country_List')) formDataObject.thirdPartyDetails.relationshipAddress.country = value ? value : '';
                                else if (formField.id.includes('relationshipAddress')) value ? formDataObject.thirdPartyDetails.relationshipAddress[key] = value : '';
                                else if (formField.id.includes('countryCode')) value ? formDataObject.thirdPartyDetails.telephone = `${value.slice(0, -4)}` : '';
                                else if (formField.id.includes('telephone_telephone')) value ? formDataObject.thirdPartyDetails.telephone += value : '';
                                else if (formField.id.includes('dateofBirth')) value ? formDataObject.thirdPartyDetails[key] = (value = value.split('-'), value.push(value.shift()), value = value.join('/')) : currentDate;
                                else value ? formDataObject.thirdPartyDetails[key] = value : '';
                            }
                        });
                    }
                    fetchCountrySearchValue(thidPartyData, formDataObject);
                }
            }

            if (KoreanCustomer) {
                let korean = 'Korean';
                formDataObject = { ...formDataObject , sender : { ...formDataObject.sender, preferredLanguage : pageLang , countryRestriction: korean }}
            }

            checkCountryFieldValid(formDataObject) && getAPIResponse(formDataObject);
        } else {
            !humanKey ? displayCaptchaAlert() : '';
        }
    };

    window.checkCountryFieldValid = (formDataObject) => {
        let countryFieldsvalid = true;
        const CORLabel = document.querySelector(`#sender_address_country_countryLabel`);
        const COBLabel = document.querySelector(`#sender_countryofBirth_countryLabel`);
        const toggler1 = document.querySelector('#toggle1');

        if (Boolean(formDataObject?.sender?.address?.country)) { 
            CORLabel && CORLabel.classList.remove('text-danger');
        } else {
            CORLabel && CORLabel.classList.add('text-danger'); 
            (toggler1 && !toggler1.checked) && (toggler1.checked = !toggler1.checked);
            countryFieldsvalid = false;
        }
        if (Boolean(formDataObject?.sender?.countryofBirth)) {
            COBLabel && COBLabel.classList.remove('text-danger');
        } else {
            COBLabel && COBLabel.classList.add('text-danger'); 
            (toggler1 && !toggler1.checked) && (toggler1.checked = !toggler1.checked);
            countryFieldsvalid = false;
        }
        return countryFieldsvalid;
    }

    window.displayCaptchaAlert = () => {
        const errorMsg = document.querySelector(".gcr-msg-fail");
        const captchaMsg = document.querySelector(".gcr-msg-captcha");
        errorMsg && captchaMsg ? (captchaMsg.classList.remove('d-none'), errorMsg.classList.add('d-none')) : '';
    }

    window.getAPIResponse = (formDataObject) => {
        const submitEventLog = document.getElementById('button-submit-questionnaire');
        const loadingSpinner = document.querySelector(".gcr-form-wu-spinner");
        const captchaMsg = document.querySelector(".gcr-msg-captcha");
        const errorMsg = document.querySelector(".gcr-msg-fail");
        const addPersonStopMsg = document.querySelector(".gcr-msg-add-person-stop");
        const addPersonFailMsg = document.querySelector(".gcr-msg-add-person-fail");

        const submittedForm = document.querySelector(".sample_gcr_form");
        const successPage = document.querySelector("#success_page");

        const senderEmail = document.querySelector("#sender_emailAddress");
        const emailAddressString = senderEmail ? senderEmail.value : '';
        const emailText = document.createTextNode(`${emailAddressString}`);
        const emailIdWrapper = document.querySelector("#Scccess_Page_emailId");

        const isGCRV2Enabled = handleAPIVersioning();

        loadingSpinner ? loadingSpinner.classList.remove("d-none") : '';
        captchaMsg ? captchaMsg.classList.add('d-none') : '';
        errorMsg ? errorMsg.classList.add('d-none') : '';
        addPersonFailMsg && addPersonStopMsg && (addPersonFailMsg.classList.add('d-none'), addPersonStopMsg.classList.add('d-none'));

        let apiVersion = 'wuconnect/cmplkyc/gcr/v1';
        isGCRV2Enabled && (apiVersion = 'cmplkyc/gcr/v2');
        const submiturl = `https://${current_hostname}/${apiVersion}/initiateGCR/postGcrForm`;
        const headers = { "Content-type": "application/json" };
        const payload = { ...formDataObject };

        httpRequest.post(submiturl, payload, headers).then((response) => {
            loadingSpinner.classList.add("d-none");
            if (response) {
                setCookie('gcrSubmit', true, 10) ;
                if (response.compositeResponse && response.compositeResponse.length > 0) {

                    const res = response.compositeResponse[1].body;
                    if (res.Id && res.CaseNumber) {
                        submittedForm ? (clearFormData(submittedForm), submittedForm.classList.add('d-none')) : '';
                        successPage ? successPage.classList.remove('d-none') : '';
                        emailIdWrapper && emailText ? emailIdWrapper.appendChild(emailText) : '';
                        current_hostname === 'www3.westernunion.com' ? console.log(`Id : ${res.Id} , CaseNumber : ${res.CaseNumber}`) : '';
                        submitEventLog && submitEventLog.click();
                    } else {
                        errorMsg.classList.remove('d-none');
                    }
                } else if (response.issues && response.issues.length && response.errorCode === '400') {
                    errorMsg.classList.remove('d-none');
                } else {
                    errorMsg.classList.remove('d-none');
                }
            } else {
                errorMsg.classList.remove('d-none');
            };
        }).catch(error => {
            loadingSpinner.classList.add("d-none");
            errorMsg.classList.remove('d-none');
            console.error(error);
        });
    }

    window.clearFormData = (formContents) => {
        formContents.reset();
        attachmentData = {};

        const imgFiles = formContents.querySelectorAll('.global_img_preview');
        imgFiles && imgFiles.length ? imgFiles.forEach(className => (className.src = "", className.classList.add("d-none"))) : '';

        const pdfFiles = formContents.querySelectorAll('.global_pdf_preview');
        pdfFiles && pdfFiles.length ? pdfFiles.forEach(className => (className.innerHTML = "", className.classList.add("d-none"))) : '';

        const fwEdit = formContents.querySelectorAll('.global_FW_edit');
        fwEdit && fwEdit.length ? fwEdit.forEach(className => className.classList.add("d-none")) : '';

        const defaultIcon = formContents.querySelectorAll('.icon-globe-latlng');
        defaultIcon && defaultIcon.length ? defaultIcon.forEach(className => className.classList.remove("d-none")) : '';

        const flagIcon = formContents.querySelectorAll('.country-search-select');
        flagIcon && flagIcon.length ? flagIcon.forEach(className => className.classList.add("d-none")) : '';

        const editBlock = formContents.querySelectorAll('.global_editBlock');
        editBlock && editBlock.length ? editBlock.forEach(className => (className.src = "", className.classList.add("d-none"))) : '';

        const attachLabel = formContents.querySelectorAll('.attachLabel');
        attachLabel && attachLabel.length ? attachLabel.forEach(className => (className.src = "", className.classList.remove('opac-0'))) : '';

        const countryAddressSelect = formContents.querySelector('#sender_address_country_List');
        countryAddressSelect ? countryAddressSelect.value = "" : '';

        const countryAddressTemp = formContents.querySelector('#sender_address_country_tempData');
        countryAddressTemp ? countryAddressTemp.innerHTML = "" : '';

        const countryBirthSelect = formContents.querySelector('#sender_countryofBirth_List');
        countryBirthSelect ? countryBirthSelect.value = "" : '';

        const countryBirthTemp = formContents.querySelector('#sender_countryofBirth_tempData');
        countryBirthTemp ? countryBirthTemp.innerHTML = "" : '';

        const thirdPartyCountrySelect = formContents.querySelector('#thirdPartyDetails_relationshipAddress_country_List');
        thirdPartyCountrySelect ? thirdPartyCountrySelect.value = "" : '';

        const thirdPartyCountryTemp = formContents.querySelector('#thirdPartyDetails_relationshipAddress_country_tempData');
        thirdPartyCountryTemp ? thirdPartyCountryTemp.innerHTML = "" : '';
    }

    // Toggle window.- Normal Cases
    window.enableToggleContent = (id) => {
        if (id !== 'thirdPartyDetails') {
            let control = document.getElementById(id);
            let FCLabel = document.querySelectorAll(".enableTC_" + id);
            if (undefinedCheck(control) && undefinedCheck(FCLabel)) {
                FCLabel.forEach((el) => {
                    el.classList.toggle('d-none');
                    el.classList.toggle('reqValidate');
                    control.checked ? '' : el.classList.contains('wu-input__error') ? el.classList.remove('wu-input__error') : '';
                });
            }
        } else {
            thirdPartyToggleContent(id)
        }
    }

    // Toggle window.- Special Case - Third Party Details Section
    window.thirdPartyToggleContent = (id) => {
        let control = document.getElementById(id);
        if (undefinedCheck(control)) {
            if (control.checked) {
                let initialFields = ["reasonforActing", "reasonforMoneyUsed", "individualorBusiness"];
                initialFields.forEach((fieldName) => {
                    let field = document.getElementById(`${id}_${fieldName}`);
                    if (undefinedCheck(field)) {
                        field.parentElement.parentElement.classList.remove('d-none');
                        field.parentElement.parentElement.classList.add('reqValidate');
                        control.checked ? '' : field.parentElement.classList.contains('wu-input__error') ? field.parentElement.classList.remove('wu-input__error') : '';
                    }
                });
            } else {
                let section = document.querySelector("#form-section-thirdPartyDetails");
                if (undefinedCheck(section)) {
                    let allFormControls = section.querySelectorAll('input:not([type="checkbox"]) , select');
                    if (undefinedCheck(allFormControls.length)) {
                        allFormControls.forEach((fieldName) => {
                            fieldName.value = '';
                            fieldName.parentElement.parentElement.classList.add('d-none');
                            fieldName.parentElement.parentElement.classList.remove('reqValidate');
                            control.checked ? '' : fieldName.parentElement.classList.contains('wu-input__error') ? fieldName.parentElement.classList.remove('wu-input__error') : '';
                        });
                    }
                }
            }
        }
    }

    let selectCountry_list, dropDownContainer, accordianContainer, country_List, defaultFlagIcon, flagIcon, getCountryCode, getPreviousCountryVal, getPreviousCountryFlag, dropDown_Container_G;

    window.selectState = (e) => {
        selectCountry_list = document.getElementById(e + "_List");
        dropDownContainer = document.getElementById(e + "_ContainerDD");
        accordianContainer = document.getElementById("toggle1");
        country_List = dropDownContainer.querySelectorAll("li");
        defaultFlagIcon = document.getElementById(e + "_default-flag-icon");
        flagIcon = document.getElementById(e + "_flagIcon");
        getPreviousCountryVal = document.getElementById(e + "_tempData");
        dropDown_Container_G = document.querySelectorAll(".dropDown_Container");

        selectCountry_list.value = "";

        dropDown_Container_G.forEach(className => {
            className.classList.remove('active');
            if (getPreviousCountryVal.innerText != null) {
                selectCountry_list.value = getPreviousCountryVal.innerText;
            }
        });
        dropDownContainer.classList.add("active");
        accordianContainer.classList.add("overflowVis");
        country_List.forEach((el) => {
            el.classList.add('d-flex');
            el.style.display = "";
        });

        selectCountry_list.addEventListener('keyup', (event) => {
            let filter, li, a, i, txtValue;
            filter = selectCountry_list.value.toUpperCase();
            a = dropDownContainer.getElementsByTagName("li");
            for (i = 0; i < a.length; i++) {
                li = a[i].getElementsByTagName("span")[0];
                txtValue = li.textContent || li.innerText;
                if (txtValue.toUpperCase().indexOf(filter) === 0) {
                    a[i].style.display = "";
                    a[i].classList.add('d-flex');
                } else {
                    a[i].style.display = "none";
                    a[i].classList.remove('d-flex');
                }
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target.className.indexOf("selectStateAndCountry") == -1) {
                dropDownContainer.classList.remove("active");
                accordianContainer.classList.remove("overflowVis");
                if (getPreviousCountryVal.innerText != null) {
                    selectCountry_list.value = getPreviousCountryVal.innerText;
                    selectCountry_list.classList.add('wu-input--is-focus');
                }
            }
        });
    }

    window.selectCountry = (e, getId) => {
        selectCountry_list.focus();
        getCountryCode = e.getAttribute("data-flag-select-value").toLowerCase();
        getPreviousCountryVal.innerText = e.textContent.trim();
        getPreviousCountryFlag = getCountryCode;
        selectCountry_list.value = e.textContent.trim();
        defaultFlagIcon.classList.add('d-none');
        flagIcon.classList.remove(...flagIcon.classList);
        flagIcon.classList.add('wu-flag', 'flag__1x1', 'bdr-clr-idel', 'bdr-thin-all', 'bdr-radius-cir', 'wu-flag__spacing-scale-md', 'country-search-select');
        flagIcon.classList.add(getCountryCode);
        dropDownContainer.classList.remove("active");
        accordianContainer.classList.remove("overflowVis");
        selectCountry_list.blur();
    }

    let attachmentData = {}

window.fileWidget = (id, getField) => {
    let photo = document.getElementById(id+"_"+getField);
    let imgPreview = document.getElementById("imgPreview_" + id);
    let file_Attach_Container = document.getElementById("FW_Con_"+id);
    let FW_Edit = document.getElementById("FW_Edit_" + id);
	let fileExtension = ["png", "jpg", "jpeg", "pdf"];
    const file = photo.files[0];
	let getFileExtension = file.name.split(".")[1].toLowerCase();
	let fileSize = file.size;
	let size = parseFloat(fileSize / (1024 * 1024)).toFixed(2);
	let pdfPreview = document.getElementById("pdfPreview_" + id);
	let editOption = document.getElementById("editOpt_" + id);
	let label_FW = document.getElementById(id + "_Label");
	
	if (file && (fileExtension.indexOf(getFileExtension) > -1) && (size < 10)){
        let reader = new FileReader();
        reader.onload = (event) => {
			if(getFileExtension == "pdf"){
				imgPreview.classList.add('d-none'); 
				pdfPreview.classList.remove('d-none');
				pdfPreview.innerHTML = file.name;
				pdfPreview.setAttribute('title', file.name);
			}
			else{
				pdfPreview.classList.add('d-none');
				imgPreview.classList.remove('d-none');            
				imgPreview.src = URL.createObjectURL(file);
				file_Attach_Container.classList.add('opac-0');
			}
			FW_Edit.classList.remove('d-none');
            const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
            attachmentData[id] = {
                "fileName": file.name,
                "data": base64String
            }
        };
		
		let visi = document.querySelectorAll(".setOverflowVisCont");
		visi.forEach(className => {
		className.style.overflow = "hidden";
		});	
		editOption.classList.add("d-none");
		label_FW.classList.remove("wu-input__error");
		photo.value = "";
        reader.readAsDataURL(file);
		
    }else{
		label_FW.classList.add("wu-input__error");
	}
}

let fileCounter = {
    SOI_FileWidget: 0,
    PI_FileWidget: 0,
    POT_FileWidget: 0
}; // to make sure fileCount is 5
//dummy logic for enablement of V2 APIs

let fileSet = []; // maintained for api operations
let editDocName; // document to be edited

    window.submitMultipleFiles = () => {
        fileSections.forEach((value) => {
            fileSet.forEach((file) => {
                if (value === file.id && finalFileSubmitObj[value]) {
                    finalFileSubmitObj[value].push({
                        documentKey: file.fileKey
                    });
                }
            })
        });
        finalFileSubmitObj = {
            SOI_FileWidget: [...new Set(finalFileSubmitObj.SOI_FileWidget.map(JSON.stringify))].map(JSON.parse),
            PI_FileWidget: [...new Set(finalFileSubmitObj.PI_FileWidget.map(JSON.stringify))].map(JSON.parse),
            POT_FileWidget: [...new Set(finalFileSubmitObj.POT_FileWidget.map(JSON.stringify))].map(JSON.parse),
        }
    }

window.createUploadHeading = () => { //creates dynamic heading for upload section
    let uploadHeading = document.getElementById('upload-heading');
    uploadHeading.classList.remove('d-none');
    uploadHeading.classList.add('upload-heading', 'font-weight-normal' ,'mar-xl-tp');
    return uploadHeading;
}

window.createUploadText = () => { //creates dynamic text for upload section
    let uploadText = document.getElementById('upload-text');
    uploadText.classList.remove('d-none');
    uploadText.className = "font-body-sm";
    return uploadText;
}

    window.userEmailExists = () => {
        const senderEmail = document.querySelector("#sender_emailAddress");
        const emailMsg = document.querySelector(".gcr-msg-email");
        if (!senderEmail.value) {
            emailMsg.classList.remove('d-none');
            window.scrollTo(0, 0);
            return false;
        } else {
            emailMsg.classList.contains('d-none') ? ' ' : emailMsg.classList.add('d-none');
            return true;
        }
    }

    window.addFileWidget = (id, getField, event) => {
        if (!isGCRV2Enabled) {
            fileWidget(id, getField);
        } else {
            if (fileCounter[id] < 5 && userEmailExists()) {
                // First update the new file in UI
                const file = event.target.files[0];
                if (file) {
                    const fileLabelImage = document.getElementById(`${id}_Label`);
                    const fileHeadingImage = document.getElementById(`${id}_Heading`);
                    // We don't have to compress files that aren't images
                    if (!file.type.startsWith('image')) {
                        uploadToServer(id,event,file);
                        fileLabelImage?.classList?.remove('text-danger'); 
                        fileHeadingImage?.classList?.remove('text-danger');
                    } else {
                        createImageBitmap(file).then(imageBitmap => {
                            const compressionPercentage = 0.5;
                            const canvas = document.createElement('canvas');
                            canvas.width = imageBitmap.width;
                            canvas.height = imageBitmap.height;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(imageBitmap, 0, 0);
                            // We compress the file by 50%  
                            const newCanvas = canvas;
                            const blob = new Promise((resolve) =>
                            newCanvas.toBlob(resolve, file.type, compressionPercentage)
                            ).then(blob => {
                                const compressedFile = new File([blob], file.name, {
                                    type: blob.type
                                });
                               uploadToServer(id,event,compressedFile);
                                fileLabelImage?.classList?.remove('text-danger'); 
                                fileHeadingImage?.classList?.remove('text-danger');
                            });
                        });
                    }                  
                }
            } else {
                event.target.value = null;
                return;
            }
        }
    }

    window.uploadToServer = (id,event,file) => {
        let uploadSection = document.getElementById("uploadSection" + id);
        addDynamicTextAndHeading(uploadSection);
        let fileSize = file.size;
        let size = parseFloat(fileSize / (1024 * 1024)).toFixed(2);
        if (size < 10) {
            uploadToS3Bucket(file, id, 'addMode', event);
        }
    }

window.addDynamicTextAndHeading = (uploadSection) => {
    if (!uploadSection.hasChildNodes()) { //add dynamic heading and text
        uploadSection.append(createUploadHeading());
        uploadSection.append(createUploadText());
    }
}

window.buildMultipleFilesUI = (file,  id ) => { //creates dynamic source for images or pdf selected
    let getFileExtension = file.name.split(".")[1].toLowerCase();
    let uploadContainer = document.getElementById("imgContainer_" + id);
    let editOption = document.getElementById("editOpt_" + id);
    let div = document.createElement('div');
    let editIcon = document.createElement('i');
    div.setAttribute('document-name',file.name);
    div.classList.add('documents-holder', 'position-relative', 'd-flex');
    editIcon.classList.add('wu-icon', 'icon-0073_edit', 'action', 'cursor-pointer', 'editBtn_FW');
    editIcon.addEventListener('click',function(e){
        showEditOptions(e);
    });
    if(getFileExtension == 'pdf'){
        let pdfElement = document.createElement('div');
        pdfElement.classList.add('d-flex', 'align-items-center', 'justify-content-center','upload-img','bdr-thick-all', 'bdr-radius-S', 'bdr-clr-active'); // update the innerHTML
        pdfElement.innerHTML = file.name;
        div.appendChild(pdfElement);
    } else {
        let img = document.createElement('img');
        img.classList.add('d-flex', 'align-items-center', 'justify-content-center','upload-img','bdr-thick-all', 'bdr-radius-S', 'bdr-clr-active'); 
        img.src = URL.createObjectURL(file); // update the src of image
        div.appendChild(img);
    }
    div.appendChild(editIcon);
    let editWidgetContainer = document.createElement('div');
    editWidgetContainer = editOption.cloneNode(true);
    div.appendChild(editWidgetContainer);
    // creates the final div
    uploadContainer.append(div);
}
window.uploadToS3Bucket = (file, id, mode, event) => {
    const loadingSpinner = document.querySelector(".gcr-form-wu-spinner");
    const errorMsg = document.querySelector(".gcr-msg-fail");
    loadingSpinner ? loadingSpinner.classList.remove("d-none") : '';
    const sectionId = id.split("_")[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    const senderEmail = document.querySelector("#sender_emailAddress");
    loadingSpinner.classList.remove('d-none');
    reader.onload = () => {
        const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
        let uploadData = {
            "emailAddress": senderEmail.value,
            "fileName": sectionId + "_" + file.name,
            "data": base64String,
            'captchaUuid': uniqueReferenceID
        }
        let submiturl = `https://${current_hostname}/cmplkyc/gcr/v2/initiateGCR/addImage`;
        httpRequest.post(submiturl, uploadData, header)
        .then((res) => {
            loadingSpinner.classList.add("d-none");
             fileCounter[id] = fileCounter[id] >= 5 ? fileCounter[id] : fileCounter[id] + 1;
             let fileObj = {
                 fileName: file.name,
                 fileNumber: res.documentNumber,
                 fileKey: res.documentKey,
                 id: id
             }
             fileSet.push(fileObj);

             if (mode === 'addMode') {
                 buildMultipleFilesUI(file, id);
             } else {
                 handleEditModeUi(id, event, file, mode)
             }

        }).catch(error => {
            loadingSpinner.classList.add("d-none");
            errorMsg.classList.remove('d-none');               
        });
       
    }
}

window.showEditOptions = (event) => {
   event.target.nextElementSibling.classList.remove('d-none');
   event.target.nextElementSibling.classList.add('show-edit-options');
}

window.handleEditModeUi = (id,event, file, mode) => {
    const src = URL.createObjectURL(event.target.files[0]);
    let targetElement = event.target.parentElement.parentElement.parentElement.children[0];
    
    if (mode !== 'editMode') {
        editDocName = event.target.parentElement.parentElement.getAttribute('document-name');
    } else {
        editDocName = event.target.parentElement.parentElement.parentElement.getAttribute('document-name');
    }
    let getFileExtension = file.name.split(".")[1].toLowerCase();
    if (getFileExtension == 'pdf') {
        // in case img is being replaced with pdf file
        if (targetElement.tagName == 'DIV') {
            targetElement.innerHTML = file.name;
        } else {
            let pdfElement = document.createElement('div');
            pdfElement.classList.add('d-flex', 'align-content-center', 'justify-content-center','upload-img'); 
            pdfElement.innerHTML = file.name;
            targetElement.replaceWith(pdfElement);
        }
    } else {
        if (targetElement.tagName == 'IMG') {
            targetElement.src = src;
        } else {
            // in case pdf is being replaced with image file
            let img = document.createElement('img');
            img.classList.add('d-flex', 'align-content-center', 'justify-content-center','upload-img'); 
            img.src = URL.createObjectURL(file);
            targetElement.replaceWith(img);
        }
    }
    removeSelection(id,event, 'editMode');
    event.target.parentElement.parentElement.parentElement.setAttribute('document-name', file.name)
}

window.handleFileEdit = (id, event, gtId) => {
    if (!isGCRV2Enabled) {
        fileWidget(id, gtId); // OLD ONE
    } else {
        const file = event.target.files[0];
        if (file) {
            let fileSize = file.size;
            let size = parseFloat(fileSize / (1024 * 1024)).toFixed(2);
            if (size < 10) {
                // Add the new File in S3
                uploadToS3Bucket(file, id, 'editMode', event);
            } else {
                return;
            }
        }
    }
}

window.removeSelection = (id, event, mode) => {
    if (!isGCRV2Enabled) {
        removeDocument(id);
    } else {
        const loadingSpinner = document.querySelector(".gcr-form-wu-spinner");
        const errorMsg = document.querySelector(".gcr-msg-fail");
        loadingSpinner ? loadingSpinner.classList.remove("d-none") : '';
        let docName; 
        // Remove the file from the UI
        if (mode !== 'editMode') {
            docName = event.target.parentElement.parentElement.getAttribute('document-name');
        } else {
             docName = editDocName;
        }
        let fileToBeRemoved = fileSet.filter((x) => {
            return x.fileName == docName && id == x.id;
        });
        // Now update the same in S3Bucket, remove the same file
        let dataToBeRemoved =
        {
            "documentNumber": fileToBeRemoved[0].fileNumber,
            "captchaUuid": uniqueReferenceID,
            "documentKey": fileToBeRemoved[0].fileKey
        }
        const submitUrl = `https://${current_hostname}/cmplkyc/gcr/v2/initiateGCR/deleteImage`;
        httpRequest.post(submitUrl, dataToBeRemoved, header)
        .then((res) => {
            loadingSpinner.classList.add("d-none");
            if (mode !== 'editMode') {
                event.target.parentElement.parentElement.remove();
                fileCounter[id] = fileCounter[id] - 1;
            }
            let index = fileSet.indexOf(fileToBeRemoved[0]);
            if (index !== -1) {
                fileSet.splice(index, 1);
            }
            if (finalFileSubmitObj[fileToBeRemoved[0].id] !== undefined) {
                let filteredFileArr = finalFileSubmitObj[fileToBeRemoved[0].id].filter(x => x.documentKey !== fileToBeRemoved[0].fileKey);
                finalFileSubmitObj[fileToBeRemoved[0].id] = [...filteredFileArr];
            }
        }).catch(error => {
            loadingSpinner.classList.add("d-none");
            errorMsg.classList.remove('d-none');               
        });


    }
}

window.showEditOption = (getId, counter) => {
    let showEditLabel = document.getElementById("editOpt_" + getId);
	showEditLabel.classList.toggle('d-none');
    if(checkDevice()){
        let visi = document.getElementById("setOverflowVisCont_" + counter);
        if (showEditLabel.classList.contains("d-none")) {
            visi.style.overflow = "hidden"
        }
        else{
            visi.style.overflow = "visible";
        }
    }
}

window.removeDocument = (getId) => {
    let imgPreview = document.getElementById("imgPreview_" + getId);
    let FW_Edit = document.getElementById("FW_Edit_" + getId);
    let editOpt = document.getElementById("editOpt_" + getId);
	let pdfPreview = document.getElementById("pdfPreview_" + getId);
	let file_Attach_Container = document.getElementById("FW_Con_" + getId);

    FW_Edit.classList.add('d-none');
    editOpt.classList.add('d-none');
    imgPreview.classList.add('d-none');
    imgPreview.src = "";
	pdfPreview.classList.add('d-none');
	pdfPreview.innerHTML = "";

    attachmentData[getId].fileName = "";
    attachmentData[getId].data = "";
	file_Attach_Container.classList.remove('opac-0');
	
	let visi = document.querySelectorAll(".setOverflowVisCont");
	visi.forEach(className => {
		className.style.overflow = "hidden";
	});	
}


document.addEventListener('click', (e) => {
	if (e.target.className.indexOf("editBtn_FW") == -1) {		
		let editLabelFW =  document.querySelectorAll('.editLabel_FW');
		editLabelFW.forEach(className => {
		className.classList.add("d-none");
		});
		let visi = document.querySelectorAll(".setOverflowVisCont");
		visi.forEach(className => {
		className.style.overflow = "hidden";
		});
	} 
});
    
    window.sortSelect =(selElem) => {
        let tmpAry = new Array();
        let op;
        for (let i = 0; i < selElem.options.length; i++) {
            tmpAry[i] = new Array();
            tmpAry[i] = selElem.options[i].text.split("+")[1];
        }
        const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', {
            numeric: true
        });
        tmpAry = tmpAry.sort(sortAlphaNum);
        for (let i = 0; i < tmpAry.length; i++) {
            op = new Option("+" + tmpAry[i]);
            selElem.options[i] = op;
        }
        return;
    }

    window.addEmptyElement = (selElem) => {
        let opt = new Option('', '', 'selected');
        selElem.insertBefore(opt, selElem.firstChild);
        selElem.selectedIndex = "0";
    }

    window.KoreanCustomerOption = (event) => {
        let checkBoxKorea =  event.target;
        let PISection = document.getElementById('form-section-PersonalInformation');
        let fileControl = PISection.querySelectorAll('[type="file"]');
        let arrayLabel = fileControl[0].id.slice(0, -3);
        let fileHeading = document.querySelector(`#${arrayLabel}_Heading`);
        let fileLabel = document.querySelector(`#${arrayLabel}_Label`);
        
        if (checkBoxKorea.checked) {
            KoreanCustomer = true;
            fileControl.length && (fileControl.forEach(fileControl => fileControl.classList.remove('reqValidate')),fileControl[0].parentElement.parentElement.parentElement.classList.add('d-none'));
            fileHeading && (fileHeading.classList.add('d-none'),fileHeading.classList.remove('text-danger'));
            fileLabel && (fileLabel.classList.add('d-none'),fileLabel.classList.remove('text-danger'));
        } else {
            KoreanCustomer = false;
            fileControl.length && (fileControl.forEach(fileControl => fileControl.classList.add('reqValidate')),fileControl[0].parentElement.parentElement.parentElement.classList.remove('d-none'));
            fileHeading && (fileHeading.classList.remove('d-none'),fileHeading.classList.remove('text-danger'));
            fileLabel && (fileLabel.classList.remove('d-none'),fileLabel.classList.remove('text-danger'));
        }

    }
}
